export default {
  filterHome: (state) => {
    return state.filters.home;
  },
  filterProcedimento: (state) => {
    return state.filters.procedimento;
  },
  filterContas: (state) => {
    return state.filters.contas;
  },
  accounts: (state) => {
    return state.accounts;
  },
  procedures: (state) => {
    return state.procedures;
  },
  adminAccounts: (state) => {
    return state.accounts.filter((account) => account.role == 2);
  },
  totalAccounts: (state) => {
    return state.accounts.length;
  },
  totalProcedures: (state) => {
    return state.procedures.length;
  },
  totalRecovered: (state) => {
    return state.procedures.filter((procedure) => procedure.patientSaved)
      .length;
  },
  totalDeaths: (state) => {
    return state.procedures.filter((procedure) => !procedure.patientSaved)
      .length;
  },
  totalCompanyAccounts: (state) => {
    return state.accounts.filter((account) => account.isCompany).length;
  },
  totalAggregateAccounts: (state) => {
    return state.accounts.filter(
      (account) => account.companyCnpj && !account.isCompany
    ).length;
  },
  totalIndividualAccounts: (state) => {
    return state.accounts.filter(
      (account) => !account.isCompany && !account.companyCnpj
    ).length;
  },
  totalTrainings: (state) => {
    return state.procedures.filter(
      (procedure) => procedure.procedureType === "training"
    ).length;
  },
  totalBlockedAccounts: (state) => {
    return state.accounts.filter((account) => account.blocked).length;
  },
  mostRecurrentStates: (state) => {
    let states = [];
    const filteredProcedures = state.procedures.filter(
      (procedure) => procedure.procedureLocation.state != ""
    );

    for (
      let procedureIndex = 0;
      procedureIndex < filteredProcedures.length;
      procedureIndex++
    ) {
      if (states.length) {
        const stateIndex = states.findIndex(
          (state) =>
            state.name ===
            filteredProcedures[procedureIndex].procedureLocation.state
        );

        if (stateIndex === -1) {
          states.push({
            name: filteredProcedures[procedureIndex].procedureLocation.state,
            count: 1,
          });
        } else {
          states[stateIndex].count++;
        }
      } else
        states.push({
          name: filteredProcedures[procedureIndex].procedureLocation.state,
          count: 0,
        });
    }
    states.sort((a, b) => {
      if (a.count > b.count) {
        return -1;
      }
      if (a.count < b.count) {
        return 1;
      }
      return 0;
    });

    if (states.length > 5) states = states.slice(0, 5);

    return states;
  },
  mostRecurrentCities: (city) => {
    let cities = [];
    const filteredProcedures = city.procedures.filter(
      (procedure) => procedure.procedureLocation.city != ""
    );
    for (
      let procedureIndex = 0;
      procedureIndex < filteredProcedures.length;
      procedureIndex++
    ) {
      if (cities.length) {
        const cityIndex = cities.findIndex(
          (city) =>
            city.name ===
            filteredProcedures[procedureIndex].procedureLocation.city
        );

        if (cityIndex === -1) {
          cities.push({
            name: filteredProcedures[procedureIndex].procedureLocation.city,
            count: 1,
          });
        } else {
          cities[cityIndex].count++;
        }
      } else
        cities.push({
          name: filteredProcedures[procedureIndex].procedureLocation.city,
          count: 0,
        });
    }
    cities.sort((a, b) => {
      if (a.count > b.count) {
        return -1;
      }
      if (a.count < b.count) {
        return 1;
      }
      return 0;
    });
    if (cities.length > 5) cities = cities.slice(0, 5);
    return cities;
  },
  drugsCounter: (state) => {
    return [
      {
        name: "Adrenalina",
        count: state.procedures.reduce(
          (sum, { drugs: { adrenalina } }) => sum + adrenalina,
          0
        ),
      },
      {
        name: "Amiodarona",
        count: state.procedures.reduce(
          (sum, { drugs: { amiodarona } }) => sum + amiodarona,
          0
        ),
      },
      {
        name: "Lidocaína",
        count: state.procedures.reduce(
          (sum, { drugs: { lidocaina } }) => sum + lidocaina,
          0
        ),
      },
      {
        name: "Atropina",
        count: state.procedures.reduce(
          (sum, { drugs: { atropina } }) => sum + atropina,
          0
        ),
      },
    ];
  },
  shocksCounter: (state) => {
    return [
      {
        name: "Fibrilação Ventricular",
        count: state.procedures.reduce(
          (sum, { shocks: { fibrilacao_ventricular } }) =>
            sum + fibrilacao_ventricular,
          0
        ),
      },
      {
        name: "Taquicardia Ventricular",
        count: state.procedures.reduce(
          (sum, { shocks: { taquicardia_ventricular } }) =>
            sum + taquicardia_ventricular,
          0
        ),
      },
    ];
  },
  advancedAirwaysCounter: (state) => {
    return [
      {
        name: "Confirmada",
        count: state.procedures.reduce(
          (sum, { advancedAirways: { confirmada } }) => sum + confirmada,
          0
        ),
      },
      {
        name: "Esofágica",
        count: state.procedures.reduce(
          (sum, { advancedAirways: { esofagica } }) => sum + esofagica,
          0
        ),
      },
      {
        name: "Orotraqueal",
        count: state.procedures.reduce(
          (sum, { advancedAirways: { orotraqueal } }) => sum + orotraqueal,
          0
        ),
      },
    ];
  },
  otherCounter: (state) => {
    return [
      {
        name: "Assistolia",
        count: state.procedures.reduce(
          (sum, { other: { assistolia } }) => sum + assistolia,
          0
        ),
      },
      {
        name: "OVACE",
        count: state.procedures.reduce(
          (sum, { other: { ovace } }) => sum + ovace,
          0
        ),
      },
      {
        name: "AESP",
        count: state.procedures.reduce(
          (sum, { other: { aesp } }) => sum + aesp,
          0
        ),
      },
    ];
  },
};
